import * as SHOP from '../constants/Shop';

const initialState = {
    userInfo: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SHOP.GET_SHOP_INFO_FULFILLED:
            if (action.payload.data) {
                return {
                    ...state,
                    userInfo: action.payload.data.memberInfo,
                };
            }
        default:
            return state;
    }
}